import { IAccountSubscriptionPlanInfo, IAccountSubscriptionPlanPricing } from "../../Types"

export enum AccountViewCurrency {
  EUR = "EUR",
  USD = "USD",
}

interface AccountViewPlanBlockBaseProps {
  active: boolean;
  cancelCallback: () => void;
  canSubscribe: boolean;
  currency: AccountViewCurrency;
  plan: IAccountSubscriptionPlanInfo;
}

export interface AccountViewPlanBlockProps extends AccountViewPlanBlockBaseProps {
  selectCallback: (pricing: IAccountSubscriptionPlanPricing) => void;
}

export type AccountViewPlanBlockNonStripeProps = AccountViewPlanBlockBaseProps;
